import { querystringToObj } from 'app/common/utils/UrlUtils';
import { getCookie, setCookie } from 'app/common/CommonUtils';

const AB_IDENTITY_COOKIE_NAME = 'abidentity';

export const getIdentity = () => {
  const { identity } = querystringToObj() || {};
  const cookie = getCookie(AB_IDENTITY_COOKIE_NAME);

  // Check to see if we should clear the identity cookie. Return undefined, as we
  // would if the identity URL parameter wasn't set.
  if (identity === '0') {
    setCookie(AB_IDENTITY_COOKIE_NAME, '', 1);
    return undefined;
  }

  // If the URL parameter has been provided, set the cookie with a max-age of
  // one hour, and return the new identity.
  if (identity) {
    setCookie(AB_IDENTITY_COOKIE_NAME, identity, 3600);
    return identity;
  }

  // Last, return the cookie. If the cookie has expired or doesn't exist, this
  // will return undefined.
  return cookie;
};
